import { render, staticRenderFns } from "./lsn_invite.vue?vue&type=template&id=5cb10e2b&scoped=true"
import script from "./lsn_invite.vue?vue&type=script&lang=js"
export * from "./lsn_invite.vue?vue&type=script&lang=js"
import style0 from "./lsn_invite.vue?vue&type=style&index=0&id=5cb10e2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb10e2b",
  null
  
)

export default component.exports